/**
 * Version Badge Component
 *
 * Displays current version number and opens changelog modal.
 * Story 7-2
 */

import { useState } from 'react';
import { useChangelog } from './useManual';
import { ChangelogModal } from './ChangelogModal';

export function VersionBadge() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: versions } = useChangelog();

  // Get the latest version number
  const currentVersion = versions && versions.length > 0 && versions[0]
    ? versions[0].versionNumber
    : '1.0.0';

  return (
    <>
      <button
        data-testid="manual-version"
        onClick={() => setIsModalOpen(true)}
        className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
        title="Versiegeschiedenis bekijken"
      >
        <svg
          className="w-3 h-3 mr-1.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        Versie {currentVersion}
      </button>

      <ChangelogModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
